module.exports = __webpack_public_path__ + "img/sys9-select.39e231ae.png";